import {
	GET_TEAMS,
	GET_TEAMS_SUCCESS,
	GET_TEAMS_FAILURE,
	ADD_USER_TO_TEAM,
} from './types';

export const getTeamsAction = () => ({
	type: GET_TEAMS,
});

export const getTeamsSuccessAction = (payload: any) => ({
	type: GET_TEAMS_SUCCESS,
	payload,
});

export const getTeamsFailureAction = (error: Error) => ({
	type: GET_TEAMS_FAILURE,
	payload: error,
});

export const addUserToTeamAction = (payload: any) => ({
	type: ADD_USER_TO_TEAM,
	payload,
});
